import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Card } from "@mui/material";
import EmployeeDetails from "./EmployeeDetails";
import EmployeeDependents from "./EmployeeDependents";
import EmployeeAddress from "./EmployeeAddress";
import BankDetails from "./BankDetails";
import EmployeeDocument from "./EmployeeDocument";
import Experience from "./Experience";
import UploadImage from "./uploadImage";
import AddTechnology from "./AddTechnology";
import UploadDocument from "./UploadDocument";
import { GET } from "APIclient";
 
function TabPanel(props) {
  const { children, value, index, ...other } = props;
 
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
 
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
 
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `secondary full-width-tabpanel-${index}`,
  };
}
 
export default function FullWidthTabs() {
  const theme = useTheme();
  const [isLoading, setIsLoading] = React.useState(true);
  const [value, setValue] = React.useState(0);
  const [passUser, setPassUser] = React.useState([]);
 
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
 
  const url1 = `employee/employee-details/${window.sessionStorage.getItem("empId")}`;
 
  React.useEffect(() => {
    const controller = new AbortController();
    const fetchData = async () => {
      try {
        const response = await GET(url1, { signal: controller.signal });
        console.log("response", response?.data || []);
        const data = response.data?.data || response;
 
        if (data && response.data.statusCode === 200) {
          setPassUser(data);
          console.log("testdata", data);
        }
      } catch (error) {
        if (error.name === "AbortError") return;
        console.error("Error adding data:", error);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    };
 
    fetchData();
 
    return () => {
      controller.abort();
    };
  }, []);
 
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox sx={{ bgcolor: "background.paper", borderBottom: 1, borderColor: "divider" }}>
        <AppBar position="static">
          <Card>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="secondary"
              style={{ background: "" }}
              textColor="secondary"
              aria-label="full width secondary tabs example"
            >
              <Tab label="Details" {...a11yProps(0)} />
              <Tab label="Dependents" {...a11yProps(1)} />
              <Tab label="Address" {...a11yProps(2)} />
              <Tab label="Bank Details" {...a11yProps(3)} />
              <Tab label="Documents" {...a11yProps(4)} />
              <Tab label="Previous Experience" {...a11yProps(5)} />
              <Tab label="Add Technology" {...a11yProps(6)} />
              <Tab label="Upload Image" {...a11yProps(7)} />
            </Tabs>
          </Card>
        </AppBar>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <EmployeeDetails details={passUser} />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <EmployeeDependents dependents={passUser} />
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <EmployeeAddress details={passUser} />
        </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction}>
          <BankDetails details={passUser} />
        </TabPanel>
        <TabPanel value={value} index={4} dir={theme.direction}>
          <EmployeeDocument details={passUser} />
        </TabPanel>
        <TabPanel value={value} index={5} dir={theme.direction}>
          <Experience experiences={passUser?.experiences} />
        </TabPanel>
        <TabPanel value={value} index={6} dir={theme.direction}>
          <AddTechnology />
        </TabPanel>
        <TabPanel value={value} index={7} dir={theme.direction}>
          <UploadImage />
        </TabPanel>
      </MDBox>
    </DashboardLayout>
  );
}
 